var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.useNewVersion)?_c('IssuesNewCustomerDependent'):_c('IssuesNew')}
var staticRenderFns = []

export { render, staticRenderFns }